import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const MissionRentService = {
    async addMissionRent(missionRentData) {
        try {
            const response = await axios.post(`${apiUrl}/RentMission`, missionRentData);
            return response.data;
        } catch (error) {
            console.error("Error adding mission rent:", error);
            throw error;
        }

    },
    async getRentsByAgendaId(agenda_id) {
        try {
            const response = await axios.get(`${apiUrl}/RentMission/getRentByAgenda/${agenda_id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching rents by agenda ID:", error);
            throw error;
        }
    },
    async getRentById(rent_id) {
        try {
            const response = await axios.get(`${apiUrl}/RentMission/getRentById/${rent_id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching rent by ID:", error);
            throw error;
        }
    },
    async deleteRentById(rent_id) {
        try {
            const response = await axios.delete(`${apiUrl}/RentMission/${rent_id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting rent by ID:", error);
            throw error;
        }
    },

    async getRentSettings(directionId = null) {
        try {
            const url = directionId
                ? `${apiUrl}/RentMission?direction_id=${directionId}`
                : `${apiUrl}/RentMission`;
            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error("Error fetching rent settings:", error);
            if (error.response) {
                return error.response.data;
            }
            throw error;
        }
    },

    async createRentSetting(rentData) {
        try {
            const response = await axios.post(`${apiUrl}/RentMission`, rentData);
            return response.data;
        } catch (error) {
            console.error("Error creating rent setting:", error);
            if (error.response) {
                return error.response.data;
            }
            throw error;
        }
    },

    async deleteRentSetting(rentId) {
        try {
            const response = await axios.delete(`${apiUrl}/Rent/${rentId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting rent setting:", error);
            if (error.response) {
                return error.response.data;
            }
            throw error;
        }
    },
}

export default MissionRentService;
